<template>
    <div class="table-box dark-block">
        <page-title class="flex justify-content-between">
            <span>用户管理</span>
            <div class="search-group flex" @click.stop>
                <Select style="width: 100px" class="margin-lr-20" v-model="curSearchField" placeholder="请选择搜索字段..." @on-change="changeField()">
                    <Option v-for="item in displayField" :value="item.code" :key="item.code">{{ item.name }}</Option>
                </Select>
                <Input v-if="curSearchField !== 'sex'" style="width: 150px" v-model="curSearchTxt" placeholder="请输入" clearable @on-enter="searchResult">
                <Icon type="ios-search" slot="suffix" @click="searchResult" />
                </Input>
                <Select v-if="curSearchField === 'sex'" v-model="curSearchTxt" @on-change="searchResult">
                    <Option v-for="item in genderList" :key="`gender-${item.val}`" :value="item.val">{{ item.label }}</Option>
                </Select>
            </div>
        </page-title>
        <Row :gutter="20" class="margin-tb-15">
            <Col :span="isShowSearchResult ? '0' : '5'" class="left-col">
            <Card class="tree-card">
                <div slot="title" class="tree-filter-header">
                    <enc-tree-search
                        :title="'所在机构'"
                        @handelAdd="handleAddRootDeptPop"
                        @handelSearch="deptListFilter"></enc-tree-search>
                </div>
                <div class="tree-block-organ scrollbar">
                    <enc-tree ref="encTree" :filter-method="deptFilter" :data-array="departData" value-key="id" :draggable="true" :render="renderContent" @on-select-change="handleDepartSelect" @on-dragend="handleDepartDragEnd"></enc-tree>
                </div>
            </Card>
            </Col>
            <Col :span="isShowSearchResult ? '24' : '19'" class="right-col" :class="isShowSearchResult ? 'full-col' : ''">
            <Card>
                <p v-if="isShowSearchResult" class="margin-tb-20 border theme-color cursor-point" @click.stop="backHistory"><Icon type="ios-arrow-back"></Icon>搜索结果：共{{ totalPage }}个相关内容</p>
                <div class="button-group ivu-row-flex align-center justify-content-between margin-b-10">
                    <div>
                        <Button v-show="!isShowSearchResult" type="primary" icon="ios-add-circle-outline" class="right-margin icon-btn" @click="changeObj('c')">新建用户</Button>
                        <Button icon="md-trash" class="right-padding icon-btn" @click="handleBatchDel">批量删除</Button>
                    </div>
                    <div>
                        <Icon class="theme-color cursor-point" type="md-settings" size="20" @click="openUserAttrDialog"></Icon>
                    </div>
                </div>
                <div class="scrollbar" :class="isShowSearchResult ? 'search-table' : 'table-data'">
                    <Table :row-class-name="() => 'table-row'" :columns="columns" :data="tableData" :no-data-text="'暂无数据'"
                           @on-selection-change="(selection) => handleChoiceColumn(selection, 'one')"
                           @on-select-all="(selection) => handleChoiceColumn(selection, 'all')"
                           @on-select-cancel="(selection, row) => handleCancelChoice(selection, 'one', row)"
                           @on-select-all-cancel="(selection) => handleCancelChoice(selection, 'all')">
                        <template slot-scope="{ row }" slot="roleName">
                            <div class="cursor-point" style="width: 96%;">
                                <div class="role-name-list" :title="row.roleName">{{ row.roleName }}</div>
                            </div>
                        </template>
                        <template slot-scope="{ row }" slot="createTime">
                            {{ row.userInfo[0].createTime }}
                        </template>
                        <template slot-scope="{ row }" slot="sex">
                            <span v-if="row.userInfo[0].sex == 1">女</span>
                            <span v-else>男</span>
                        </template>
                        <template slot-scope="{ row }" slot="action">
                            <div class="action-group" v-if="row.id !== 1 && row.id != loginUserInfo.userId">
                                <Tooltip content="重置密码" placement="top">
                                    <Icon type="ios-unlock-outline" size="20" class="theme-color cursor-point" @click="resetPwd(row)"></Icon>
                                </Tooltip>
                                <Tooltip content="编辑" placement="top">
                                    <Icon type="ios-create-outline" size="20" class="margin-lr-10 cursor-point theme-color"  @click="updateUserInfo(row)"></Icon>
                                </Tooltip>
                                <Tooltip content="删除" placement="top">
                                    <Icon type="ios-trash-outline" class="theme-color cursor-point" size="20"  @click="handleBatchDel(row)"></Icon>
                                </Tooltip>
                            </div>
                        </template>
                    </Table>
                </div>
                <Page ref="selection" class="text-left padding-top-20"  :current="curPage" :page-size="pageSize" :total="totalPage"
                      size="small" show-total show-elevator show-sizer
                      @on-change="changePage"
                      @on-page-size-change="changePageSize"/>
            </Card>
            </Col>
        </Row>
        <create-update-user-info :obj="createUserObj" @closeTip="createUserObj.isShow = false" @refreshPage="initData()"></create-update-user-info>
        <remove-dialog :obj="removeDialogObj" @closeDialog="handleCloseDelDialog"></remove-dialog>
        <update-user-attr-dialog :obj="userAttrObj" @closeDialog="handleCloseAttrDialog"></update-user-attr-dialog>
        <Modal
            :title="currentDeptNode.id?'编辑机构':'新建机构'"
            v-model="deptModal"
            @on-ok="handleSaveDept">
            <Form ref="deptForm" :model="currentDeptNode" :rules="deptFormRule" label-position="left" :label-width="88">
                <FormItem label="机构名称" prop="deptName">
                    <Input ref="deptName" :disabled="!!currentDeptNode.id" v-model="currentDeptNode.deptName" placeholder="请输入机构名称"></Input>
                </FormItem>
                <FormItem label="机构编码" prop="deptCode">
                    <Input v-model="currentDeptNode.deptCode" placeholder="请输入机构代码"></Input>
                </FormItem>
                <FormItem label="所属机构" v-if="currentDeptNode.id">
                    <enc-tree ref="dropdownTree" :dropdown-select="true" :clearable="true"  :inner-filter="true" value-key="id" label-key="deptName" v-model="currentDeptNode.parentId" :data-array="editDepartData"  title-name="deptName" @on-select-change="handleEditDepartSelect"></enc-tree>
                </FormItem>
                <FormItem label="签章" prop="deptSignature" v-if="isShowSignature">
                    <template v-if="currentDeptNode.deptSignature && currentDeptNode.deptSignature.length">
                        <div class="upload-img-box" v-for="(url,index) in currentDeptNode.deptSignature" :key="url">
                            <img class="upload-img" :src="url">
                            <div class="icon-label">
                                <Icon type="ios-checkmark" size="24"></Icon>
                                <Icon type="ios-close" size="24" @click="handleUploadRemove(index)"></Icon>
                            </div>
                        </div>
                    </template>
                    <Upload
                        ref="upload"
                        name="file"
                        :headers="uploadHeaders"
                        :show-upload-list="false"
                        :on-success="handleUploadSuccess"
                        :on-error="handleUploadError"
                        :format="['jpg','jpeg','png','bmp']"
                        :action="batchUpload">
                        <div class="add-item">
                            <Icon type="ios-add" size="32"></Icon>
                        </div>
                    </Upload>
                </FormItem>
            </Form>
            <div class="footer" slot="footer">
                <Button @click="handleCloseDeptModal">取消</Button>
                <Button type="primary" :loading="deptSaveLoading" @click="handleSaveDept">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import CreateUpdateUserInfo from './components/createUpdateUserInfo.vue';
import RemoveDialog from './components/removeDialog.vue';
import updateUserAttrDialog from './components/updateUserAttrDialog.vue';
import eventMix from './mix/eventMix';
import requestMix from './mix/requestMix';
import api from '../../common/api';
import utils from '../../common/utils';
import EncTree from '../../components/EncTree.vue';
import EncTreeSearch from '../../components/EncTreeSearch.vue';
import common from '../../common/common';
import gConfig from '../../config'

export default {
    name: 'UserList',
    data() {
        return {
            showSignature: false,
            data: {},
            curPage: 1,
            totalPage: 0,
            pageSize: 20,
            curOperator: '',
            curOperatorId: '',
            curSearchField: 'loginName',
            curSearchTxt: '',
            displayField: [],
            curDeptInfo: '',
            loginUserInfo: common.getLoginUserInfo(),
            isShowSignature: false,
            isShowSearchResult: false,
            genderList: [{
                label: '全部',
                val: '-1'
            }, {
                label: '男',
                val: '0'
            }, {
                label: '女',
                val: '1'
            }],
            userAttrObj: {
                isShow: false,
                title: '用户属性配置',
                attrList: []
            },
            createUserObj: {
                type: '',
                isShow: false,
                title: '新建用户',
                dept: null,
                deptList: [],
                attrList: []
            },
            removeDialogObj: {
                isShow: false,
                title: '提示',
                content: '确定要删除所选行吗?'
            },
            tableData: [],
            tableExpend: [],
            curChoiceUser: [],
            columns: [],
            // treeFilter: false,
            deptSaveLoading: false,
            departData: [],
            childrenKey: 'children',
            deptFilterStr: '',
            deptModal: false,
            currentDeptNode: {},
            parentDeptNode: {},
            deptFormRule: {
                deptName: [
                    { required: true, message: '机构名不能为空', trigger: 'blur' }
                ],
                deptCode: [
                    { required: true, message: '机构编码不能为空', trigger: 'blur' },
                    { pattern: /^[0-9a-zA-Z]+$/g, message: '机构编码只能包含数字和字母', trigger: 'blur' }
                ]
            },
            batchUpload: api.batchUpload,
            uploadHeaders: {},
            defaultFileList: [],
            prevTreeNode: {},
        }
    },
    components: {
        CreateUpdateUserInfo,
        RemoveDialog,
        updateUserAttrDialog,
        EncTree,
        EncTreeSearch,
    },
    mixins: [eventMix, requestMix],
    computed: {
        editDepartData() {
            return JSON.parse(JSON.stringify(this.departData))
        }
    },
    async created() {
        await this.getDeptList();
        await this.initData();
        this.getDisplayField();
        this.uploadHeaders = {
            [gConfig.headerTokenKey]: common.getLocalToken()
        };
    },
    methods: {
        async changeObj(type, data) {
            await this.getUserAttrList()
            switch (type) {
            case 'c':
                Object.assign(this.createUserObj, {
                    type: 'create',
                    title: '新建用户',
                    dept: this.curDeptInfo
                })
                break;
            case 'e':
                Object.assign(this.createUserObj, {
                    type: 'edit',
                    title: '编辑用户',
                    userInfo: data,
                    dept: this.curDeptInfo
                })
                break;
            default:
                break;
            }
            this.createUserObj.isShow = true
        },
        changeField() {
            if (this.curSearchField === 'sex') {
                this.curSearchTxt = '-1'
                this.searchResult()
            }
            if (this.curSearchField !== 'sex' && ['-1', '0', '1'].includes(this.curSearchTxt)) {
                this.curSearchTxt = ''
            }
        },
        filterTableData(data) {
            this.totalPage = data.recordTotal
            this.tableData = data.data.map((item) => {
                item = {
                    ...item.userInfo[0],
                    ...item,
                    roleNameList: item.roleName.split(',')
                }
                return item
            })
        },
        getDeptList() {
            return new Promise((resolve, reject) => {
                api.getDeptList({
                    pageNum: 0,
                    pageSize: 9999
                }).then((res) => {
                    if (res.resultCode === 0 && res.data && res.data.data && res.data.data.length) {
                        const departData = utils.arrayToTree(res.data.data, { key: 'id', parentKey: 'parentId', childrenKey: this.childrenKey }, { dropDownVisible: false });
                        this.departData = utils.treeSort(departData, this.childrenKey, 'orderNum');
                        this.departData[0].selected = true
                        // eslint-disable-next-line prefer-destructuring
                        this.curDeptInfo = this.departData[0]
                        this.createUserObj.deptList = JSON.parse(JSON.stringify(this.departData));
                        resolve(this.departData)
                    } else {
                        resolve([])
                    }
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        // eslint-disable-next-line no-unused-vars
        renderContent(h, { root, node, data }) {
            const self = this;
            return h('span', {}, [
                h('span', {
                    domProps: {
                        title: data.deptName
                    },
                    class: 'tree-node-text'
                }, data.deptName),
                h('Dropdown', {
                    style: {
                        fontSize: '20px',
                        position: 'absolute',
                        right: '0px'
                    },
                    props: {
                        trigger: 'custom',
                        visible: data.dropDownVisible,
                        placement: 'bottom-end',
                        'stop-propagation': true
                    },
                    on: {
                        'on-clickoutside': () => { data.dropDownVisible = false; }
                    }
                }, [
                    h('Icon', {
                        props: {
                            type: 'md-more'
                        },
                        style: {
                            fontSize: '20px',
                            position: 'absolute',
                            right: '0px',
                            top: '8px'
                        },
                        on: {
                            click: (e) => {
                                e.stopPropagation();
                                if (self.prevTreeNode) {
                                    self.prevTreeNode.dropDownVisible = false;
                                }
                                data.dropDownVisible = true;
                                self.prevTreeNode = data;
                            }
                        }
                    }),
                    h('DropdownMenu', {
                        slot: 'list'
                    }, [
                        h('DropdownItem', {
                            props: {
                                name: 'add'
                            },
                            nativeOn: {
                                click: ($event) => {
                                    $event.stopPropagation();
                                    this.treeDropDownClick('add', { root, node, data })
                                }
                            }
                        }, '添加下级'),
                        h('DropdownItem', {
                            props: {
                                name: 'edit'
                            },
                            nativeOn: {
                                click: ($event) => {
                                    $event.stopPropagation();
                                    this.treeDropDownClick('edit', { root, node, data })
                                }
                            }
                        }, '编辑'),
                        h('DropdownItem', {
                            props: {
                                name: 'delete'
                            },
                            nativeOn: {
                                click: ($event) => {
                                    $event.stopPropagation();
                                    this.treeDropDownClick('delete', { root, node, data })
                                }
                            }
                        }, '删除'),
                    ])
                ])
            ])
        },
        deptFilter(node) {
            return node.deptName.indexOf(this.deptFilterStr) > -1
        },
        deptListFilter(val) {
            this.deptFilterStr = val;
            this.$refs.encTree.filter(this.deptFilterStr);
        },
        getShowSignature(data) {
            const temp = data.filter((item) => item.code === 'signature' && item.enable)
            this.isShowSignature = temp.length > 0
        },
        handleAddRootDeptPop() {
            this.$refs.deptForm.resetFields();
            this.getUserAttrList()
            this.currentDeptNode = {
                orderNum: 0,
                deptSignature: null
            };
            const { treeData } = this.$refs.encTree;
            this.currentDeptNode.orderNum = treeData[treeData.length - 1].orderNum + 1;
            this.parentDeptNode = null;
            this.deptModal = true;
            // this.$nextTick(() => {
            //     this.$refs.deptName.focus()
            // })
        },
        // eslint-disable-next-line max-params
        treeDropDownClick(name, { root, node, data }) {
            this.$refs.deptForm.resetFields();
            // eslint-disable-next-line default-case
            switch (name) {
            case 'add':
                this.currentDeptNode = {
                    orderNum: 1,
                    deptSignature: null
                };
                this.parentDeptNode = data;
                // eslint-disable-next-line no-case-declarations
                const children = this.parentDeptNode.children || [];
                this.parentDeptNode.children = children;
                if (children.length) {
                    this.currentDeptNode.orderNum = children[children.length - 1].orderNum + 1;
                }
                this.deptModal = true;
                // this.$nextTick(() => {
                //     this.$refs.deptName.focus()
                // })
                data.dropDownVisible = false;
                break;
            case 'edit':
                this.parentDeptNode = node.node;
                this.currentDeptNode = JSON.parse(JSON.stringify(node.node));
                if (this.currentDeptNode.deptSignature && typeof this.currentDeptNode.deptSignature === 'string') {
                    this.currentDeptNode.deptSignature = this.currentDeptNode.deptSignature.split(';')
                }
                this.deptModal = true;
                data.dropDownVisible = false;
                break;
            case 'delete':
                data.dropDownVisible = false;
                this.currentDeptNode = node.node;
                this.$Modal.confirm({
                    title: '提示',
                    loading: true,
                    content: `<div>您确定要删除机构 ${this.currentDeptNode.deptName} 吗？</div>`
                        + '<div>该机构下包含的子级将被一并删除</div>',
                    onOk: () => {
                        api.delDepts([this.currentDeptNode.id]).then((res) => {
                            if (res.resultCode === 0) {
                                this.$Message.success('删除成功');
                                const nodeIndex = root.findIndex((el) => el === node);
                                const parentKey = root[nodeIndex].parent;
                                const parentNode = root.find((el) => el.nodeKey === parentKey);
                                if (parentNode) {
                                    const parent = parentNode.node;
                                    const index = parent.children.indexOf(data);
                                    parent.children.splice(index, 1);
                                    if (!parent.children.length) {
                                        parent.expand = false;
                                    }
                                } else {
                                    const i = this.$refs.encTree.treeData.findIndex((el) => el.id === data.id);
                                    this.$refs.encTree.treeData.splice(i, 1);
                                }
                            } else {
                                this.$Message.warning(res.resultMessage || '删除失败');
                            }
                            this.$Modal.remove();
                        }).catch((e) => {
                            console.log(e)
                            this.$Message.error(e.resultMessage || '删除异常');
                            this.$Modal.remove();
                        })
                    }
                });
                break;
            }
        },
        handleSaveDept() {
            this.$refs.deptForm.validate((valid) => {
                if (valid) {
                    this.deptSaveLoading = true;
                    if (!this.currentDeptNode.id) {
                        const params = {
                            ...this.currentDeptNode,
                            parentId: this.parentDeptNode ? this.parentDeptNode.id : 0
                        };
                        if (params.deptSignature) {
                            params.deptSignature = params.deptSignature.join(';')
                        }
                        api.addDept(params).then((res) => {
                            if (res.resultCode === 0 && res.data) {
                                this.$Message.success('新增成功');
                                res.data.expand = true;
                                this.$set(res.data, 'dropDownVisible', false)
                                if (!this.parentDeptNode) {
                                    this.$refs.encTree.treeData.push(res.data)
                                } else {
                                    this.parentDeptNode.expand = true;
                                    this.parentDeptNode.children.push(res.data);
                                    this.$set(this.parentDeptNode, 'children', this.parentDeptNode.children)
                                }
                                this.deptModal = false;
                            } else {
                                this.$Message.warning(res.resultMessage || '新增失败');
                            }
                            this.deptSaveLoading = false;
                        }).catch((e) => {
                            this.$Message.error(e.resultMessage || '新增异常');
                            this.deptModal = false;
                            this.deptSaveLoading = false;
                        })
                    } else {
                        const params = {
                            ...this.currentDeptNode,
                        };
                        if (params.deptSignature) {
                            params.deptSignature = params.deptSignature.join(';')
                        }
                        api.editDept(params).then((res) => {
                            if (res.resultCode === 0) {
                                this.$Message.success('编辑成功');
                                if (this.currentDeptNode.parentId !== this.parentDeptNode.parentId) {
                                    this.getDeptList();
                                } else {
                                    Object.assign(this.parentDeptNode, this.currentDeptNode);
                                    this.parentDeptNode.dropDownVisible = false;
                                }
                                this.deptModal = false;
                            } else {
                                this.$Message.warning(res.resultMessage || '编辑失败');
                            }
                            this.deptSaveLoading = false;
                        }).catch((e) => {
                            this.$Message.error(e.resultMessage || '编辑异常');
                            this.deptModal = false;
                            this.deptSaveLoading = false;
                        })
                    }
                }
            })
        },
        handleCloseDeptModal() {
            this.deptModal = false;
        },
        handleDepartDragEnd(e, opt) {
            const { data, target, direction } = opt;
            if (direction === 'inner' || target.parentId !== data.parentId) {
                this.$Message.warning('只能同级内拖拽');
            } else {
                api.deptSort({
                    id: data.id,
                    oldOrderNum: data.orderNum,
                    orderNum: target.orderNum,
                    parentId: data.parentId
                }).then((res) => {
                    if (res.resultCode === 0) {
                        opt.success();
                        this.$Message.success('排序成功');
                    } else {
                        this.$Message.warning(res.resultMessage || '排序失败');
                    }
                }).catch((err) => {
                    this.$Message.error(err.resultMessage || '排序异常');
                })
            }
        },
        handleDepartSelect(selections, node) {
            console.log('tt=====', selections, node)
            if (selections.length < 1) {
                this.$refs.encTree.setSelectedNodes([node.id]);
            }
            this.curPage = 1
            this.curDeptInfo = node
            this.initData()
        },
        handleEditDepartSelect(selections, node) {
            if (node) {
                this.currentDeptNode.parentIdDeptName = node.deptName;
            } else {
                this.currentDeptNode.parentIdDeptName = '';
                this.currentDeptNode.parentId = 0;
            }
        },
        handleUploadSuccess(res, file) {
            console.log(res, file);
            if (res.resultCode === 0 && res.data) {
                this.currentDeptNode.deptSignature = this.currentDeptNode.deptSignature || [];
                this.currentDeptNode.deptSignature.push(...res.data.replace(/;$/, '').split(';'))
            } else {
                this.$Message.warning(res.resultMessage || '图片上传失败');
            }
        },
        handleUploadError(error, file, fileList) {
            this.$Message.error('图片上传失败');
            console.log(error, file, fileList)
        },
        handleUploadRemove(index) {
            this.currentDeptNode.deptSignature.splice(index, 1)
        },
    },
    beforeDestroy() {
        console.log('beforeDestroy', this)
    },
    destroyed() {
        console.log('destroyed', this)
    }
}

</script>
<style lang="less" scoped>
    .ivu-row{
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    .ivu-col{
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .role-name-list {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        width: 100%;
    }
    .left-col{
        padding-right: 12px !important;
        width: 296px;
    }
    .right-col{
        width: calc(100% - 285px - 12px);
    }
    .full-col{
        width: 100%;
    }
    .ivu-select-selection {
        width: 100px;
    }
    .table-box{
        width: 100%;
    }
    .tag-flex {
        display: flex;
        height: 26px;
        flex-wrap: wrap;
        overflow: hidden;
    }
    .com-block {
        background: var(--comp-block-bg-color);
    }
    /deep/ .ivu-tag {
        word-break: keep-all;
    }
    /deep/ .ivu-tag-text {
        white-space: nowrap;
    }
    .margin-b-10 {
        margin-bottom: 20px;
    }
    .button-group{
        margin-top: 5px;
    }
    .table-data {
        height: calc(100vh - 230px);
        /*overflow-y: scroll;*/
    }
    .search-table {
        height: calc(100vh - 280px);
        /*overflow-y: scroll;*/
    }
    .right-margin {
        margin-right: 20px;
    }
    .border {
        font-weight: bold;
    }
    /deep/ .tree-card {
        height: calc(100vh - 96px);
        overflow: hidden;
        transition: none;
        .ivu-card-body{
            height: 92%;
        }
    }
    /deep/ .tree-node-text{
        text-overflow: ellipsis;
        position: relative;
        width: 90%;
        overflow: hidden;
        display: inline-block;
    }
    .tree-block-organ{
        height: calc(100vh - 220px);
        overflow-x: hidden;
    }
    .upload-img-box{
        position: relative;
        display: inline-block;
        width: 50px;
        height: 50px;
        margin-right: 10px;
        border: 1px dashed var(--divider-color);
        border-radius: 5px;
        cursor: pointer;
        overflow: hidden;
        &:hover{
            border: 1px dashed var(--comp-selected-color);
        }
        .upload-img{
            width: 100%;
            height: 100%;
            border-radius: 5px;
        }
        .icon-label{
            position: absolute;
            right: -17px;
            top: -7px;
            width: 46px;
            height: 26px;
            z-index: 1;
            background: var(--comp-selected-color);
            text-align: center;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            border-radius: 0 0 5px 0;
            -webkit-box-shadow: 0 1px 1px #ccc;
            box-shadow: 0 1px 1px #ccc;
            color: #fff;
            .ivu-icon-ios-checkmark{
                display: block;
                transform: rotate(-45deg);
                line-height: 35px;
            }
            .ivu-icon-ios-close{
                display: none;
                transform: rotate(-45deg);
                line-height: 35px;
            }
            &:hover{
                .ivu-icon-ios-checkmark{
                    display: none;
                }
                .ivu-icon-ios-close{
                    display: block;
                }
            }
        }
    }
    /deep/ .ivu-upload{
        display: inline-block;
        vertical-align: top;
        width: 50px;
        height: 50px;
    }
    .add-item{
        width: 100%;
        height: 100%;
        border-radius: 5px;
        border: 1px dashed var(--divider-color);
        cursor: pointer;
        line-height: 56px;
        text-align: center;
        &:hover{
            border: 1px dashed var(--comp-selected-color);
        }
    }
    /deep/ .ivu-table-row-hover .action-group {
        display: block;
    }
</style>
